export enum ViewColumnPrefix {
  Visible = 'Visible',
}
